(() => {
  const readConfig = () => {
    const node = document.getElementById('ZanniThemeConfig');
    if (!node) return {};
    try { return JSON.parse(node.textContent || '{}'); } catch (_) { return {}; }
  };

  const whatsappUrl = (message) => {
    const number = String(readConfig().whatsappNumber || '').replace(/\D/g, '');
    return number ? `https://wa.me/${number}?text=${encodeURIComponent(message || '')}` : '#';
  };

  const track = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`zanni:${name}`, { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...detail });
  };

  function findPicker(quote) {
    const productId = String(quote.dataset.productId || '');
    const scope = quote.closest('.shopify-section, dialog') || document;
    return Array.from(scope.querySelectorAll('variant-picker')).find((item) => String(item.dataset.productId || '') === productId) || null;
  }

  function selectedVariant(quote) {
    const picker = findPicker(quote);
    const control = picker?.querySelector('fieldset input:checked, select option:checked');
    const button = quote.querySelector('[data-zanni-quote-button]');
    return {
      id: control?.dataset.variantId || button?.dataset.variantId || '',
      sku: control?.dataset.variantSku || button?.dataset.variantSku || '',
      title: control?.dataset.variantTitle || control?.value || button?.dataset.variantTitle || '',
      available: (control?.dataset.optionAvailable || button?.dataset.variantAvailable || 'false') === 'true'
    };
  }

  function syncSelection(quote) {
    const variant = selectedVariant(quote);
    const code = quote.querySelector('[data-zanni-code]');
    const status = quote.querySelector('[data-zanni-availability]');
    const note = quote.querySelector('[data-zanni-unavailable-note]');
    const button = quote.querySelector('[data-zanni-quote-button]');
    const codeLabel = quote.dataset.codeLabel || '';
    const availableLabel = quote.dataset.availableLabel || '';
    const unavailableLabel = quote.dataset.unavailableLabel || '';
    if (code) code.textContent = variant.sku ? `${codeLabel}${codeLabel ? ': ' : ''}${variant.sku}` : '';
    if (status) {
      status.textContent = variant.available ? availableLabel : unavailableLabel;
      status.classList.toggle('is-unavailable', !variant.available);
    }
    if (note) note.hidden = variant.available;
    if (button) {
      button.dataset.variantId = variant.id;
      button.dataset.variantSku = variant.sku;
      button.dataset.variantTitle = variant.title;
      button.dataset.variantAvailable = variant.available ? 'true' : 'false';
    }
    return variant;
  }

  function ensureHeaderQuote() {
    const config = readConfig();
    document.querySelectorAll('header-actions').forEach((actions) => {
      actions.querySelectorAll('[data-testid="cart-drawer-trigger"], a.action__cart').forEach((element) => element.remove());
      const existing = actions.querySelector('[data-zanni-header-quote]');
      if (!config.showHeaderQuote || !config.whatsappNumber) {
        existing?.remove();
        return;
      }
      const link = existing || document.createElement('a');
      link.href = whatsappUrl(config.headerQuoteMessage || '');
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.className = 'header-actions__action zanni-header-quote';
      link.dataset.zanniHeaderQuote = '';
      link.dataset.zanniEvent = 'click_whatsapp_advice';
      link.setAttribute('aria-label', config.headerQuoteDesktop || config.headerQuoteMobile || 'WhatsApp');
      let desktop = link.querySelector('.zanni-header-quote__desktop');
      let mobile = link.querySelector('.zanni-header-quote__mobile');
      if (!desktop) { desktop = document.createElement('span'); desktop.className = 'zanni-header-quote__desktop'; link.append(desktop); }
      if (!mobile) { mobile = document.createElement('span'); mobile.className = 'zanni-header-quote__mobile'; link.append(mobile); }
      desktop.textContent = config.headerQuoteDesktop || '';
      mobile.textContent = config.headerQuoteMobile || '';
      if (!existing) actions.append(link);
    });
  }

  function allowedSorts() {
    const config = readConfig();
    return new Map([
      ['manual', config.sortRecommended || ''],
      ['best-selling', config.sortRecommended || ''],
      ['title-ascending', config.sortAZ || ''],
      ['title-descending', config.sortZA || ''],
      ['created-descending', config.sortRecent || '']
    ]);
  }

  function simplifySorting() {
    const sorts = allowedSorts();
    document.querySelectorAll('select[name="sort_by"] option').forEach((option) => {
      if (!sorts.has(option.value)) option.remove(); else if (sorts.get(option.value)) option.textContent = sorts.get(option.value);
    });
    document.querySelectorAll('input[name="sort_by"]').forEach((input) => {
      const label = input.closest('label');
      if (!sorts.has(input.value)) label?.remove(); else {
        const text = label?.querySelector('.sorting-filter__label');
        if (text && sorts.get(input.value)) text.textContent = sorts.get(input.value);
      }
    });
  }

  function openFiltersFromUrl() {
    const config = readConfig();
    if (!config.autoOpenFiltersFromUrl) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('open_filters') !== 'true') return;
    requestAnimationFrame(() => {
      const trigger = document.querySelector('[data-testid="facets-open-button"], .facets-toggle, button[aria-controls*="facets"], button[aria-controls*="filter"]');
      if (trigger && trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
      document.querySelectorAll('details.facets__disclosure, .facets details').forEach((details) => { details.open = true; });
    });
  }

  const labelled = (label, value) => label ? `${label}: ${value}` : value;

  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-picker');
    if (picker) {
      const scope = picker.closest('.shopify-section, dialog') || document;
      scope.querySelectorAll('[data-zanni-quote]').forEach((quote) => {
        if (String(quote.dataset.productId || '') === String(picker.dataset.productId || '')) {
          const variant = syncSelection(quote);
          track('select_size', { product: quote.dataset.productTitle || '', variant: variant.title });
        }
      });
    }
    const filterInput = event.target.closest('input, select');
    const filterName = String(filterInput?.name || '').toLowerCase();
    if (filterName.includes('color')) track('filter_color', { value: filterInput.value || '' });
  });

  document.addEventListener('click', (event) => {
    const sticky = event.target.closest('[data-zanni-sticky-quote]');
    if (sticky) {
      event.preventDefault();
      document.querySelector('[data-zanni-quote-button]')?.click();
      return;
    }
    const eventLink = event.target.closest('[data-zanni-event]');
    if (eventLink) track(eventLink.dataset.zanniEvent, { href: eventLink.href || '' });
    const button = event.target.closest('[data-zanni-quote-button]');
    if (!button) return;
    event.preventDefault();
    const quote = button.closest('[data-zanni-quote]');
    if (!quote) return;
    const variant = syncSelection(quote);
    const config = readConfig();
    const codeLabel = quote.dataset.codeLabel || config.quoteCodeLabel || '';
    const lines = [
      config.quoteIntro || '',
      '',
      labelled(config.quoteProductLabel || '', quote.dataset.productTitle || ''),
      labelled(config.quoteSizeLabel || '', variant.title || config.quoteSizeFallback || ''),
      variant.sku ? labelled(codeLabel, variant.sku) : '',
      labelled(config.quoteUrlLabel || '', quote.dataset.productUrl || window.location.href),
      '',
      config.quoteOutro || ''
    ].filter((line, index, array) => line !== '' || (index > 0 && index < array.length - 1));
    track('click_whatsapp_product', { product: quote.dataset.productTitle || '', variant: variant.title, available: variant.available });
    const url = whatsappUrl(lines.join('\n'));
    if (url !== '#') window.open(url, '_blank', 'noopener,noreferrer');
  });

  function boot() {
    ensureHeaderQuote();
    simplifySorting();
    openFiltersFromUrl();
    document.querySelectorAll('[data-zanni-quote]').forEach(syncSelection);
    const template = document.querySelector('main[data-template]')?.dataset.template || '';
    if (template.includes('collection')) track('view_catalog');
    if (template.includes('product')) track('view_product', { product: document.querySelector('[data-zanni-quote]')?.dataset.productTitle || '' });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', () => { ensureHeaderQuote(); simplifySorting(); openFiltersFromUrl(); document.querySelectorAll('[data-zanni-quote]').forEach(syncSelection); });
})();
